import { render } from "./prenotazioneRicevuta.vue?vue&type=template&id=df2ec098&ts=true"
import script from "./prenotazioneRicevuta.vue?vue&type=script&lang=ts"
export * from "./prenotazioneRicevuta.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__